
interface StatCardProps {
  title: string;
  value: string | number;
  icon: string;
  trend?: {
    value: number;
    direction: 'up' | 'down';
  };
  color?: string;
}

export default function StatCard({ title, value, icon, trend, color = '#00d4ff' }: StatCardProps): JSX.Element {
  return (
    <div className="stat-card" style={{ borderLeft: `4px solid ${color}` }}>
      <div className="stat-card-header">
        <span className="stat-card-icon" style={{ color }}>
          {icon}
        </span>
        <span className="stat-card-title">{title}</span>
      </div>

      <div className="stat-card-value">{value}</div>

      {trend && (
        <div className={`stat-card-trend ${trend.direction}`}>
          <span className="trend-icon">
            {trend.direction === 'up' ? '↑' : '↓'}
          </span>
          <span className="trend-value">{Math.abs(trend.value)}%</span>
          <span className="trend-label">son aydan</span>
        </div>
      )}
    </div>
  );
}
